module.exports = __webpack_public_path__ + "img/help.01bfa574.svg";